var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState, } from 'react';
import Icon from '../icon';
import { Portal } from '../portal';
import { TooltipOverlay } from './components/TooltipOverlay';
import { TOOLTIP_ICON_SIZE } from './constants';
import { generateAnalyticsEvents } from './helpers/generateAnalyticsEvents';
import { getTooltipPosition } from './helpers/getTooltipPosition';
import { TooltipIcon } from './styles/_tooltip.styled';
export const Tooltip = (_a) => {
    var { inline = false, title = '', customTaggingEvent, componentName = 'tooltip', disabled = false, onClick, dataTest = 'tooltip', children, name, class: className, placement = 'bottom', variant = 'dark' } = _a, props = __rest(_a, ["inline", "title", "customTaggingEvent", "componentName", "disabled", "onClick", "dataTest", "children", "name", "class", "placement", "variant"]);
    const [overlayPosition, setOverlayPosition] = useState(null);
    const events = useMemo(() => {
        return generateAnalyticsEvents({ componentName, name, customTaggingEvent });
    }, [componentName, name, customTaggingEvent]);
    const updateTooltip = useCallback((newPosition) => {
        if (newPosition === null) {
            events.onClose();
        }
        else {
            events.onOpen();
        }
        setOverlayPosition(newPosition);
    }, [setOverlayPosition, events]);
    const closeTooltip = useCallback(() => {
        if (overlayPosition)
            updateTooltip(null);
    }, [updateTooltip, overlayPosition]);
    const handleClick = useCallback((event) => {
        event.preventDefault();
        if (onClick) {
            onClick();
        }
        updateTooltip(getTooltipPosition(event.target));
    }, [updateTooltip, onClick]);
    useEffect(() => {
        function handleResizeOrScroll() {
            closeTooltip();
        }
        window.addEventListener('resize', handleResizeOrScroll);
        window.addEventListener('scroll', handleResizeOrScroll);
        return () => {
            window.removeEventListener('resize', handleResizeOrScroll);
            window.removeEventListener('scroll', handleResizeOrScroll);
        };
    }, [closeTooltip]);
    return (_jsxs(_Fragment, { children: [_jsx(TooltipIcon, Object.assign({}, props, { "aria-label": "Open tooltip met meer informatie", onClick: handleClick, disabled: disabled, "data-test": `${dataTest}-icon`, "$inline": inline, "$variant": variant, type: "button", children: _jsx(Icon, { variant: "information", size: TOOLTIP_ICON_SIZE }) })), overlayPosition && (_jsx(Portal, { id: "tooltip-portal", role: "status", "data-render-target": "tooltip", children: _jsx(TooltipOverlay, { handleClose: closeTooltip, position: overlayPosition, dataTest: dataTest, className: className, title: title, placement: placement, variant: variant, children: children }) }))] }));
};
export default Tooltip;
